import React, { useContext } from 'react'

import { StatsigProvider, useClientAsyncInit } from '@statsig/react-bindings'
import { LogEventCompressionMode } from '@statsig/js-client'

import { isProduction } from 'utils/env.utils'
import { getElopageConfig } from 'utils/elopageConfig.utils'

import type { ExperimentsStore } from 'shared/stores/experiments.store'
import { UserSessionContext } from 'shared/context/user-session-provider'
import { useSessionReplay } from 'shared/context/use-session-replay'
import { getCookies } from 'libs/common/cookies'

export const AppStatsigProvider: React.FC<{
  children: React.ReactNode
  clientKey: string
  experimentsStore: ExperimentsStore
}> = ({ children, clientKey, experimentsStore }) => {
  const { userSessionId } = useContext(UserSessionContext)
  const environment = { tier: getElopageConfig('env') }
  const lang = getCookies('locale')

  const user = {
    userID: userSessionId,
    statsigEnvironment: environment,
    custom: {
      userSessionId: userSessionId,
      lang: lang,
      activeAccountType: 'app',
    },
  }

  const { client, isLoading } = useClientAsyncInit(clientKey, user, {
    logEventCompressionMode: isProduction() ? LogEventCompressionMode.Enabled : LogEventCompressionMode.Disabled,
  })

  experimentsStore.setClient(client)

  useSessionReplay({ client, enabled: !isLoading, clientKey })

  return (
    <StatsigProvider sdkKey={clientKey} client={client} user={user}>
      {children}
    </StatsigProvider>
  )
}
